// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2myVw","info":"PatientInfo_info__2xAHL"};